import { AxesHelper, SphereGeometry, MeshBasicMaterial, Mesh, BoxGeometry, WireframeGeometry, LineSegments } from 'three';
import { SceneManager } from './SceneManager';

const Debug = {
  draw_axis() {
    if (SceneManager.current) {
      SceneManager.current.add(new AxesHelper(5));
    }
  },

  draw_sphere(position, radius = 0.1, color = 0xff0000) {
    const geo = new SphereGeometry(radius, 8, 8);
    const mat = new MeshBasicMaterial({ color, wireframe: true });
    const mesh = new Mesh(geo, mat);
    if (position) mesh.position.copy(position);
    if (SceneManager.current) SceneManager.current.add(mesh);
    return mesh;
  },

  draw_cube(position, size = 0.1, color = 0x00ff00) {
    const geo = new BoxGeometry(size, size, size);
    const mat = new MeshBasicMaterial({ color, wireframe: true });
    const mesh = new Mesh(geo, mat);
    if (position) mesh.position.copy(position);
    if (SceneManager.current) SceneManager.current.add(mesh);
    return mesh;
  },

  draw_sphere_helper(sphere, color = 0xffff00) {
    const geo = new SphereGeometry(sphere.radius || 1, 16, 16);
    const wireframe = new WireframeGeometry(geo);
    const line = new LineSegments(wireframe);
    line.material.color.set(color);
    if (sphere.center) line.position.copy(sphere.center);
    if (SceneManager.current) SceneManager.current.add(line);
    return line;
  },
};

export { Debug };
